import './bootstrap';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import * as Sentry from '@sentry/vue';

import accessPlugin from '@js/Plugins/accessPlugin';
import adminUserPlugin from "@js/Plugins/adminUserPlugin";
import appPlugin from '@js/Plugins/appPlugin';
import broadcastPlugin from "@js/Plugins/broadcastPlugin";
import companyPlugin from '@js/Plugins/companyPlugin';
import countryPlugin from '@js/Plugins/countryPlugin';
import invoicesPlugin from '@js/Plugins/invoicesPlugin';
// import limitedUseRegionPlugin from '@js/Plugins/limitedUseRegionPlugin';
import networkPlugin from '@js/Plugins/networkPlugin';
import notificationsPlugin from '@js/Plugins/notificationsPlugin';
import paymentPlugin from '@js/Plugins/paymentPlugin';
import projectAttachedFilesPlugin from '@js/Plugins/projectAttachedFilesPlugin';
import projectClientPlugin from '@js/Plugins/projectClientPlugin';
import projectFilesPlugin from '@js/Plugins/projectFilesPlugin';
import regionPlugin from '@js/Plugins/regionPlugin';
import serviceCurrentPricePlugin from '@js/Plugins/serviceCurrentPricePlugin';
import userPlugin from '@js/Plugins/userPlugin';
import usersPlugin from '@js/Plugins/usersPlugin';

createInertiaApp({
    // resolve: name => import(`./Components/Pages/${name}`),
    // resolve: (name) => {
    //     const pages = import.meta.glob('./Components/Pages/**/*.vue', { eager: true })
    //     return pages[`./Components/Pages/${name}.vue`]
    // },
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({
            render: () => h(App, props),
        });

        if (import.meta.env.VITE_APP_ENV === 'local') {
            // не давать браузеру "заснуть", иначе после небольшого перерыва дольше перезагружается страница
            const healthcheckCallback = () => {
                fetch(`${import.meta.env.VITE_APP_URL}/api/health-check`)
                    .catch((result) => {
                        clearInterval(healthcheckIntervalId);
                    });
            };
            const healthcheckIntervalId = setInterval(healthcheckCallback, 60 * 1000);
        }

        if (import.meta.env.VITE_APP_ENV === 'production') {
            // https://docs.sentry.io/platforms/javascript/guides/vue/#vue-3
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_VUE_DSN,
                integrations: [
                //     new Sentry.BrowserTracing({
                //         tracePropagationTargets: [import.meta.env.VITE_APP_URL],
                //         // routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                //     }),
                ],
                // // Performance Monitoring
                // tracesSampleRate: import.meta.env.SENTRY_VUE_TRACES_SAMPLE_RATE, // Capture 100% of the transactions, reduce in production!
                // // Session Replay
                // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });

            fetch(`${import.meta.env.VITE_APP_URL}/build/manifest.json?v=${Math.random().toString(36)}`)
                .then((response) => response.json())
                .then((manifest) => {
                    for (const [key, value] of Object.entries(manifest)) {
                        if (value.file.split('.').pop() === 'js') {
                            const link = document.createElement('link');
                            link.rel = 'modulepreload';
                            link.as = 'script';
                            link.crossOrigin = '';
                            link.href = `${import.meta.env.VITE_APP_URL}/build/${value.file}`;
                            document.head.append(link);
                        }
                        // if (value.file.split('.').pop() === 'css') {
                        //     const link = document.createElement('link');
                        //     link.rel = 'stylesheet';
                        //     link.href = `${window.location.origin}/build/${value.file}`;
                        //     document.head.append(link);
                        // }
                    }
                })
                .catch((result) => {
                    console.log(result);
                })
        }


        app.use(plugin);

        app.use(accessPlugin);
        app.use(adminUserPlugin);
        app.use(appPlugin);
        app.use(broadcastPlugin);
        app.use(companyPlugin);
        app.use(countryPlugin);
        app.use(invoicesPlugin);
        // app.use(limitedUseRegionPlugin);
        app.use(networkPlugin);
        app.use(notificationsPlugin);
        app.use(paymentPlugin);
        app.use(projectAttachedFilesPlugin);
        app.use(projectClientPlugin);
        app.use(projectFilesPlugin);
        app.use(regionPlugin);
        app.use(serviceCurrentPricePlugin);
        app.use(userPlugin);
        app.use(usersPlugin);

        app.mount(el);

    }
});
